import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TableLayoutService {

  private filtersUrl = 'last_settings_filters/';
  private columnsUrl = 'last_settings_columns/';

  public columns = [];
  public filters = {};

  constructor(private http: HttpClient) {
  }

  public saveColumnSettingsToServer(view: string, columns: {}, tableState: any): Observable<any> {
    const subject = new Subject<any>();

    this.http.post(this.columnsUrl, {
      view: view,
      mode: 'post',
      columns: JSON.stringify({
        columns: columns,
        tableState: tableState
      })
    }).subscribe((result) => {
      subject.next(result);
    }, () => {
    });

    return subject.asObservable();
  }

  public loadColumnSettingsFromServer(view: string): Observable<any> {
    const subject = new Subject<any>();

    this.http.post(this.columnsUrl, {
      view: view,
      mode: 'get',
    }).subscribe((result) => {
      try {
        if (result['columns'] !== '') {
          subject.next(JSON.parse(result['columns']));
        } else {
          subject.next({columns: []});
        }
      } catch (e) {
        subject.next({columns: []});
      }
    }, () => {
    });

    return subject.asObservable();
  }

  public saveFilterSettingsToServer(view, filters: {}): Observable<any> {
    const subject = new Subject<any>();

    const selectedTypes: [] = filters['selectedFilterTypes'];
    const selectedFilterEntries = filters['selectedFilterEntries'];

    if (Object.keys(selectedTypes).length === 0 && Object.keys(selectedFilterEntries).length > 0) {

    } else {
      this.http.post(this.filtersUrl, {
        view: view,
        mode: 'post',
        filters: JSON.stringify(filters)
      }).subscribe((result) => {
        subject.next(result);
      }, () => {
      });
    }

    return subject.asObservable();
  }

  public loadFilterSettingsFromServer(view: string): Observable<any> {
    const subject = new Subject<any>();

    this.http.post(this.filtersUrl, {
      view: view,
      mode: 'get'
    }).subscribe(result => {
      try {
        this.filters = JSON.parse(result['filters']);
        subject.next(this.filters);
      } catch (e) {
        subject.next([]);
      }
    }, error => {
      this.filters = [];
      subject.error(error);
    });

    return subject.asObservable();
  }

}
